<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-select v-model="tableParams.dateType" filterable  placeholder="显示类型" @change="onChange"
        style="margin-right: 15px;width: 110px">
        <el-option label="按小时" :value="0" />
        <el-option label="按日期" :value="1" />
        <el-option label="按月份" :value="2" />
        <el-option label="按年份" :value="3" />
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <!-- <div class="table__operation"></div> -->
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns" :hide="hides"
        style="padding-bottom: 10px;">
        <el-button @click="downExcel('/report/cpa/download/summary2', 'CPA时段报表', tableParams)" type="warning" size="small">下载
        </el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" @sort-change="sortChange"
        :header-cell-style="{ background: '#fafafa' }" :summary-method="tableSummary" show-summary highlight-current-row
        size="small" class="js-table" style="width: 100%">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth"
          :sortable="['reportTime', 'reqSmt', 'time', 'resSmt', 'uniShowSmt', 'uniClkSmt', 'winPrice', 'auctionPrice', 'ecpmAverage', 'uniWinSmt', 'profit', 'cpcPrice', 'effectiveResSmt'].indexOf(v.field) > -1"
          :key="i" align="center">
          <template v-slot="scope">
            <el-tag
              v-if="v.field === 'clickRate' || v.field === 'fillingRate' || v.field === 'bidRate' || v.field === 'showRat' || v.field === 'dpRate' || v.field === 'effectiveFillingRate'
            || v.field === 'effectiveShowRat'"
              type="info">{{ scope.row[v.field] }}%</el-tag>
            <span v-else-if="v.field === 'linkName'">
              {{scope.row[v.field]}}
            </span>
            <span v-else-if="v.field === 'monitorName'">
              {{scope.row[v.field]}}
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]" background
        layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import downExcelMixin from '@/mixins/downExcel'
import SearchChannelMonitorSelect from "@/components/SearchChannelMonitorSelect";
import SearchDspLinkSelect from '@/components/SearchDspLinkSelect'

export default {
  name: 'Channel/time',
  components: {
    SearchDspSelect,
    SearchChannelMonitorSelect,
    SearchDspLinkSelect,
    SearchChannelSelect,
    TableColumn,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'reportTime', title: '时间' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'uniClkSmt', title: '点击数' },
        { field: 'activate', title: '激活' },
        { field: 'evoke', title: '唤起' },
        { field: 'login', title: '登录' },
        { field: 'register', title: '注册' },
        { field: 'payment', title: '付费' },
        { field: 'customerAcquisition', title: '获客' },
        { field: 'nextStay', title: '次留' },
        { field: 'visits', title: '访问' },
        { field: 'authentication', title: '认证' },
        { field: 'placeOrder', title: '下单' },
        { field: 'finishTheOrder', title: '完单' },
        { field: 'firstCall', title: '首唤' },
        { field: 'sevenDayRetention', title: '7日留存' }
      ],
      isDsp: localStorage.getItem('accountType') === '2',
    }
  },
  created () {
    this.tableParams.dateType = 1
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/cpa/summary2'
      // this.pagination.pageSize = this.pagination.pageSize
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    tableSummary (row) {
      const arr = ['reqSmt', 'resSmt', 'uniShowSmt', 'channelEcpm', 'ecpmAverage', 'uniClkSmt', 'winPrice', 'auctionPrice', 'uniWinSmt', 'profit']
      const fixedArr = ['auctionPrice', 'winPrice']
      const fixed2Arr = ['channelEcpm', 'ecpmAverage', 'fillingRate', 'showRat', 'clickRate', 'bidRate', 'profit']
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const { data } = row
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out.push(arr.indexOf(checklists[i]) > -1 ? (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(2) : '-')
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case 'channelEcpm':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.auctionPrice) }, 0)) / (data.reduce((total, item) => { return total + Number(item.uniShowSmt) }, 0)) * 1000).toFixed(4)
                break
              case 'ecpmAverage':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.winPrice) }, 0)).toFixed(4) / (data.reduce((total, item) => { return total + Number(item.uniShowSmt) }, 0)) * 1000).toFixed(4)
                break
              case 'fillingRate':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.resSmt) }, 0)) / (data.reduce((total, item) => { return total + Number(item.reqSmt) }, 0)) * 100).toFixed(2)
                break
              case 'showRat':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.uniShowSmt) }, 0)) / (data.reduce((total, item) => { return total + Number(item.resSmt) }, 0)) * 100).toFixed(2)
                break
              case 'clickRate':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.uniClkSmt) }, 0)) / (data.reduce((total, item) => { return total + Number(item.uniShowSmt) }, 0)) * 100).toFixed(2)
                break
              case 'bidRate':
                out[i] = ((data.reduce((total, item) => { return total + Number(item.uniWinSmt) }, 0)) / (data.reduce((total, item) => { return total + Number(item.resSmt) }, 0)) * 100).toFixed(2)
                break
              case 'profit':
                out[i] = (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(4)
                break
            }
          } else {
            out.push(arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-')
          }
        }
      }
      return out
    },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    },
    upTag (tag) {
      this.tableParams.tag = tag
    },
    toQuery () {
      // this.tableParams.pageNum = this.pagination.pageNum
      // this.tableParams.pageSize = this.pagination.pageSize
      this.init()
    },
    generateTableId (data, base) {
      if (!data) return []
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid()
        if (base === 0) {
          data[i].hasChildren = true
        } else {
          data[i].dspSlotCode = data[i].slotId
          data[i].dspName = data[i].channelName
          data[i].dspSlotName = data[i].slotName
        }
      }
      return data
    },
    onChange (e) {
      this.tableParams.dateType = e
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
